import _ from 'lodash'
import React from 'react'

import { useAppConfig } from '../../hooks/useAppConfig'

function getFileNameFromUrl(url?: string): string {
  if (!url) return ''
  return _.head(_.split(_.last(_.split(url, '/')), '.')) || ''
}

export type ImageProps = React.HTMLProps<HTMLImageElement> & { crossOrigin?: any; type?: string }

export const Image = ({ src, alt, type, ...rest }: ImageProps) => {
  const { images } = useAppConfig()

  if (type) {
    const url = images[type]
    if (!url) {
      // eslint-disable-next-line no-console
      console.warn(`Missing image ${src} in image assets`)
      return null
    }
    const title = alt || getFileNameFromUrl(url)
    return <img {...rest} src={url} alt={title} title={title} />
  }

  const extension = _.last(_.split(src, '.'))

  if (extension === src && src) {
    const url = images[src]
    if (!url) {
      // eslint-disable-next-line no-console
      console.warn(`Missing image ${src} in image assets`)
      return null
    }
    const title = alt || getFileNameFromUrl(url)
    return <img {...rest} src={url} alt={title} title={title} />
  }

  const title = alt || getFileNameFromUrl(src)
  return <img {...rest} src={src} alt={title} title={title} />
}
